<template>
  <!-- Top Header -->
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex align-items-center">
        <!-- Menu Toggle Button -->
        <button @click="toggleVerticalMenu" id="vertical-menu-btn" class="btn btn-sm px-3 font-size-16 header-item" type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- LOGO -->
        <div>
          <a href="javascript:void(0);" @click="goTo('member-dashboard')" class="logo-link">
            <img src="https://pona.paysol.africa/logos/pona.png" alt="MOH" class="header-logo">
          </a>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <!-- Membership Status Badge -->
        <div class="membership-status me-3 d-none d-md-block">
          <span class="status-pill" :class="membershipActive ? 'active' : 'inactive'">
            <i class="bx" :class="membershipActive ? 'bx-check-circle' : 'bx-x-circle'"></i>
            {{ membershipActive ? 'Active Member' : 'Inactive' }}
          </span>
        </div>

        <!-- User Profile -->
        <div class="dropdown d-inline-block">
          <button id="page-header-user-dropdown" class="btn header-profile-btn" data-bs-toggle="dropdown" type="button">
            <span class="profile-name d-none d-lg-inline-block">{{ memberName }}</span>
            <i class="bx bx-chevron-down d-none d-lg-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end profile-dropdown">
            <!-- Profile Header -->
            <div class="dropdown-header-section">
              <div class="d-flex align-items-center">
                <div class="dropdown-user-info">
                  <h6>{{ memberName }}</h6>
                  <p>{{ cbhiNumber }}</p>
                </div>
              </div>
            </div>

            <div class="dropdown-body">
              <a class="dropdown-item" href="javascript:void(0);" @click="goTo('my-profile')">
                <i class="bx bx-user"></i>
                <span>My Profile</span>
              </a>
            </div>

            <div class="dropdown-footer">
              <a class="dropdown-item logout-item" href="javascript:void(0);" @click="logout">
                <i class="bx bx-power-off"></i>
                <span>Logout</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Left Sidebar Menu -->
  <div id="vertical-menu" class="vertical-menu">
    <div class="h-100" data-simplebar>
      <div id="sidebar-menu">
        <ul id="side-menu" class="metismenu list-unstyled">

          <!-- Member Info Card -->
          <li class="member-info-card">
            <div class="member-card-content">
              <div class="member-details">
                <h6 class="member-name-sidebar">{{ memberName }}</h6>
                <p class="member-id">{{ cbhiNumber }}</p>
                <span class="status-badge" :class="membershipActive ? 'active' : 'inactive'">
                  {{ membershipActive ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>
          </li>

          <!-- Main Menu -->
          <li class="menu-title">Main Menu</li>

          <li :class="{ 'mm-active': isActive('member-dashboard') }">
            <a @click.prevent="goTo('member-dashboard')" href="javascript:void(0);">
              <i class="bx bx-home-circle"></i>
              <span>Dashboard</span>
            </a>
          </li>

          <li :class="{ 'mm-active': isActive('member-coverage') }">
            <a @click.prevent="goTo('member-coverage')" href="javascript:void(0);">
              <i class="bx bxs-shield"></i>
              <span>My Coverage</span>
            </a>
          </li>

          <!-- Membership Section -->
          <li class="menu-title">Membership</li>

          <li :class="{ 'mm-active': isActive('beneficiaries-list') }">
            <a @click.prevent="goTo('beneficiaries-list')" href="javascript:void(0);">
              <i class="bx bx-group"></i>
              <span>My Beneficiaries</span>
            </a>
          </li>

          <li :class="{ 'mm-active': isActive('my-member-card') }">
            <a @click.prevent="goTo('my-member-card')" href="javascript:void(0);">
              <i class="bx bx-id-card"></i>
              <span>Membership Card</span>
            </a>
          </li>

          <!-- Payments Section -->
          <li class="menu-title">Payments</li>

          <li :class="{ 'mm-active': isActive('payment-history') }">
            <a @click.prevent="goTo('payment-history')" href="javascript:void(0);">
              <i class="bx bx-history"></i>
              <span>Payment History</span>
            </a>
          </li>


          <!-- Claims Section -->
          <li class="menu-title">Claims</li>

          <li :class="{ 'mm-active': isActive('claims-list') }">
            <a @click.prevent="goTo('claims-list')" href="javascript:void(0);">
              <i class="bx bx-file"></i>
              <span>My Claims</span>
            </a>
          </li>

          <!-- Support Section -->
          <li class="menu-title">Support</li>


          <!-- Account Section -->
          <li class="menu-title">Account</li>

          <li :class="{ 'mm-active': isActive('my-profile') }">
            <a @click.prevent="goTo('my-profile')" href="javascript:void(0);">
              <i class="bx bx-user"></i>
              <span>My Profile</span>
            </a>
          </li>

          <!-- Logout -->
          <li class="logout-menu-item">
            <a @click.prevent="logout" href="javascript:void(0);">
              <i class="bx bx-power-off"></i>
              <span>Logout</span>
            </a>
          </li>

          <!-- Renewal Reminder (Conditional) -->
          <li class="renewal-card" v-if="showRenewalReminder">
            <div class="renewal-content">
              <div class="renewal-icon">
                <i class="bx bx-calendar-exclamation"></i>
              </div>
              <div class="renewal-text">
                <h6>Renewal Due</h6>
                <p>Expires in {{ daysToExpiry }} days</p>
              </div>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberPortalNavigation',

  data() {
    return {
      currentRoute: '',

      // Member Information
      memberName: '',
      cbhiNumber: '',
      membershipActive: true,
      expiryDate: null
    };
  },

  computed: {
    memberInitials() {
      if (!this.memberName) return 'M';
      const names = this.memberName.trim().split(' ');
      if (names.length >= 2) {
        return (names[0][0] + names[1][0]).toUpperCase();
      }
      return this.memberName.substring(0, 2).toUpperCase();
    },

    showRenewalReminder() {
      return this.daysToExpiry > 0 && this.daysToExpiry <= 30;
    },

    daysToExpiry() {
      if (!this.expiryDate) return 0;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const expiry = new Date(this.expiryDate);
      const diffTime = expiry - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    }
  },

  methods: {
    isActive(route) {
      return this.currentRoute === route || sessionStorage.getItem('currentPage') === route;
    },

    goTo(route) {
      sessionStorage.setItem('currentPage', route);
      this.currentRoute = route;
      this.$router.push({ name: route });
      this.closeMobileMenu();
    },

    toggleVerticalMenu() {
      const verticalMenu = document.getElementById('vertical-menu');
      const body = document.body;

      if (verticalMenu) {
        if (window.innerWidth <= 992) {
          verticalMenu.classList.toggle('show-mobile');
          body.classList.toggle('sidebar-enable');
        } else {
          body.classList.toggle('vertical-collpsed');
          sessionStorage.setItem('menuCollapsed', body.classList.contains('vertical-collpsed'));
        }
      }
    },

    closeMobileMenu() {
      if (window.innerWidth <= 992) {
        const verticalMenu = document.getElementById('vertical-menu');
        const body = document.body;

        if (verticalMenu) {
          verticalMenu.classList.remove('show-mobile');
          body.classList.remove('sidebar-enable');
        }
      }
    },

    restoreMenuState() {
      const isCollapsed = sessionStorage.getItem('menuCollapsed') === 'true';
      if (isCollapsed && window.innerWidth > 992) {
        document.body.classList.add('vertical-collpsed');
      }
    },

    handleResize() {
      const verticalMenu = document.getElementById('vertical-menu');
      const body = document.body;

      if (window.innerWidth > 992) {
        if (verticalMenu) {
          verticalMenu.classList.remove('show-mobile');
        }
        body.classList.remove('sidebar-enable');
      } else {
        body.classList.remove('vertical-collpsed');
      }
    },

    handleOutsideClick(event) {
      const menu = document.getElementById('vertical-menu');
      const menuBtn = document.getElementById('vertical-menu-btn');

      if (window.innerWidth <= 992 &&
          menu &&
          !menu.contains(event.target) &&
          menuBtn &&
          !menuBtn.contains(event.target) &&
          document.body.classList.contains('sidebar-enable')) {
        this.closeMobileMenu();
      }
    },

    loadMemberInfo() {
      const memberInfo = sessionStorage.getItem('memberInfo');
      if (memberInfo) {
        try {
          const info = JSON.parse(memberInfo);
          this.memberName = info.name || info.fullName || info.full_name || 'Member';
          this.cbhiNumber = info.cbhiNumber || info.cbhi_number || '';
          this.membershipActive = info.status === 'active' || info.membershipActive !== false;
          this.expiryDate = info.expiryDate || info.expiry_date || null;
        } catch (e) {
          console.error('Error parsing member info:', e);
        }
      }

      // Fallback
      if (!this.memberName || this.memberName === 'Member') {
        this.memberName = sessionStorage.getItem('memberName') || 'Member';
      }
      if (!this.cbhiNumber) {
        this.cbhiNumber = sessionStorage.getItem('cbhiNumber') || '';
      }
    },

    logout() {
      sessionStorage.clear();
      this.$router.push('/member-login');
    }
  },

  mounted() {
    this.loadMemberInfo();
    this.currentRoute = sessionStorage.getItem('currentPage') || 'member-dashboard';
    this.restoreMenuState();

    window.addEventListener('resize', this.handleResize);
    document.addEventListener('click', this.handleOutsideClick);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* TOP HEADER */
/* ========================================================================= */

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  padding: 0 1.5rem;
}

/* Menu Toggle Button */
#vertical-menu-btn {
  color: white;
  font-size: 1.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  transition: background 0.2s ease;
}

#vertical-menu-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Brand / Logo */
.navbar-brand-box {
  margin-left: 1rem;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.header-logo {
  height: 45px;
  width: auto;
  object-fit: contain;
}

/* Membership Status */
.membership-status {
  margin-right: 0.5rem;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.85rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-pill.active {
  background: rgba(40, 167, 69, 0.2);
  color: #5cb85c;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.status-pill.inactive {
  background: rgba(220, 53, 69, 0.2);
  color: #ff6b6b;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

/* Profile Button */
.header-profile-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50px;
  padding: 0.5rem 1rem;
  color: white;
  transition: background 0.2s ease;
}

.header-profile-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.profile-name {
  font-weight: 500;
  font-size: 0.9rem;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Profile Dropdown */
.profile-dropdown {
  min-width: 220px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
  overflow: hidden;
  padding: 0;
}

.dropdown-header-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.dropdown-user-info h6 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e3f70;
}

.dropdown-user-info p {
  margin: 0;
  font-size: 0.8rem;
  color: #6c757d;
}

.dropdown-body {
  padding: 0.5rem 0;
}

.dropdown-body .dropdown-item,
.dropdown-footer .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  color: #495057;
  transition: all 0.2s ease;
}

.dropdown-body .dropdown-item:hover {
  background: #f8f9fa;
  color: #2c5aa0;
}

.dropdown-body .dropdown-item i,
.dropdown-footer .dropdown-item i {
  font-size: 1.1rem;
  color: #2c5aa0;
}

.dropdown-footer {
  border-top: 1px solid #e9ecef;
  padding: 0.5rem 0;
}

.logout-item {
  color: #dc3545 !important;
}

.logout-item i {
  color: #dc3545 !important;
}

.logout-item:hover {
  background: #fff5f5 !important;
}

/* ========================================================================= */
/* SIDEBAR */
/* ========================================================================= */

.vertical-menu {
  width: 250px;
  position: fixed;
  top: 70px;
  bottom: 0;
  left: 0;
  background: linear-gradient(180deg, #1e3f70 0%, #162d50 100%);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  transition: all 0.3s ease;
  overflow-y: auto;
}

#sidebar-menu {
  padding: 1rem 0;
}

.metismenu {
  padding: 0;
  margin: 0;
}

.metismenu li {
  list-style: none;
}

/* Member Info Card */
.member-info-card {
  padding: 1rem;
  margin: 0 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.member-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.member-name-sidebar {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.25rem;
}

.member-id {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  margin: 0 0 0.5rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.status-badge.active {
  background: rgba(40, 167, 69, 0.2);
  color: #5cb85c;
}

.status-badge.inactive {
  background: rgba(220, 53, 69, 0.2);
  color: #ff6b6b;
}

/* Menu Title */
.menu-title {
  padding: 1rem 1.25rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.4);
}

/* Menu Items */
.metismenu > li > a {
  display: flex;
  align-items: center;
  padding: 0.8rem 1.25rem;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  text-decoration: none;
}

.metismenu > li > a i {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  min-width: 24px;
  text-align: center;
}

.metismenu > li > a:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
}

.metismenu > li.mm-active > a {
  color: white;
  background: rgba(255, 255, 255, 0.12);
}

.metismenu > li.mm-active > a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #4a90e2 0%, #7c3aed 100%);
  border-radius: 0 4px 4px 0;
}

/* Logout Menu Item */
.logout-menu-item > a {
  color: rgba(255, 107, 107, 0.8) !important;
  margin-top: 0.5rem;
}

.logout-menu-item > a:hover {
  color: #ff6b6b !important;
  background: rgba(255, 107, 107, 0.1) !important;
}

.logout-menu-item > a i {
  color: rgba(255, 107, 107, 0.8);
}

/* Renewal Card */
.renewal-card {
  padding: 0.75rem;
  margin: 1rem 0.75rem;
}

.renewal-content {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.15) 100%);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
}

.renewal-icon {
  width: 45px;
  height: 45px;
  background: rgba(255, 193, 7, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
}

.renewal-icon i {
  font-size: 1.25rem;
  color: #ffc107;
}

.renewal-text h6 {
  color: #ffc107;
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0 0 0.25rem;
}

.renewal-text p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.75rem;
  margin: 0;
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */

@media (max-width: 992px) {
  .vertical-menu {
    transform: translateX(-100%);
  }

  .vertical-menu.show-mobile {
    transform: translateX(0);
  }

  body.sidebar-enable::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
}

@media (max-width: 768px) {
  .header-logo {
    height: 38px;
  }

  .membership-status {
    display: none !important;
  }

  .profile-name {
    display: none !important;
  }

  .header-profile-btn {
    padding: 0.5rem;
  }
}

/* Desktop collapsed state */
.vertical-collpsed .vertical-menu {
  width: 70px;
}

.vertical-collpsed .vertical-menu span:not(.status-badge) {
  display: none;
}

.vertical-collpsed .vertical-menu .member-info-card {
  padding: 0.5rem;
}

.vertical-collpsed .vertical-menu .member-details {
  display: none;
}

.vertical-collpsed .vertical-menu .menu-title {
  display: none;
}

.vertical-collpsed .vertical-menu .renewal-card {
  display: none;
}

.vertical-collpsed .metismenu > li > a {
  padding: 0.8rem;
  justify-content: center;
}

.vertical-collpsed .metismenu > li > a i {
  margin-right: 0;
}

/* ========================================================================= */
/* PRINT */
/* ========================================================================= */

@media print {
  #page-topbar,
  .vertical-menu {
    display: none !important;
  }
}
</style>